import { css } from '@emotion/react'
import { colors } from 'plume-ui'

type Props = {
  value: number | null
  placeholder: string
  children: React.ReactNode
  handler: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const NumberTextBoxWithUnit: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        display: inline-block;
      `}
    >
      <input
        placeholder={props.placeholder}
        type="number"
        onChange={props.handler}
        css={css`
          width: 80px;
        `}
        value={props.value ? props.value : ''}
      />
      <div
        css={css`
          text-align: right;
          color: ${colors.gray90};
        `}
      >
        {props.children}
      </div>
    </div>
  )
}
